import { ApiService } from "../../../config";

export type WhatsappNaFicha = {
  numeroGeoranking: string | null;
  linkNoGoogle: string | null;
  numeroNoGoogle: string | null;
  sincronizadoEm: string | null;
};

type Envelope<T> = { message?: string; error?: boolean; data?: T };

const unwrap = <T>(response: { data?: Envelope<T> }): T => {
  const body = response?.data;
  if (!body || body.error) {
    throw new Error(body?.message || "Não foi possível concluir a operação.");
  }
  return body.data as T;
};

export const whatsappApi = {
  async consultar(profileId: string): Promise<WhatsappNaFicha> {
    return unwrap(await ApiService.get(`/business-profiles/${profileId}/whatsapp`));
  },

  async salvar(profileId: string, numero: string): Promise<WhatsappNaFicha> {
    return unwrap(await ApiService.put(`/business-profiles/${profileId}/whatsapp`, { numero }));
  },
};
